import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const LumpsumApi = createAsyncThunk(
  "Lumpsum",
  async ({partner_id="", name = "", startDate = "", endDate = "" }) => {
    const params = {};
    // Add name to the query if provided
    if (partner_id) {
      params.partner_id = partner_id;
    }
    if (name) {
      params.name = name;
    }
    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/lumpsum", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      return response.data;
    }
  }
);

const LumpsumSlice = createSlice({
  name: "Lumpsum",
  initialState: {
    Lumpsum: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(LumpsumApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(LumpsumApi.fulfilled, (state, action) => {
        state.Lumpsum = action.payload;
        state.loading = false;
      })
      .addCase(LumpsumApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default LumpsumSlice.reducer;

